import { ElementNotFound } from "@senciamatch/frontend/components/ElementNotFound";
import { LoadingData } from "@senciamatch/frontend/components/LoadingData";
import { LoadingSpinner } from "@senciamatch/frontend/components/LoadingSpinner";
import { trpc } from "@senciamatch/frontend/libs/trpc";
import { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import GroupByBuilding from "./components/groupByBuilding";
import GroupByStaff from "./components/groupByStaff";
import { Header } from "./components/Header";
export type Mode = "edit" | "pickEdit" | "view";

import { useReactToPrint } from "react-to-print";

export const MatchingShowPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) return <ElementNotFound />;

  const [displayMode, setDisplayMode] = useState<"staff" | "building">("building");
  const groupByStaffRef = useRef<HTMLDivElement>(null);
  const groupByBuildingRef = useRef<HTMLDivElement>(null);
  const printGroupByStaffFn = useReactToPrint({ contentRef: groupByStaffRef });
  const printGroupByBuildingFn = useReactToPrint({ contentRef: groupByBuildingRef });

  const getWorkShiftGroup = trpc.getWorkShiftGroup.useQuery({ id });

  const onPrint = () => {
    if (displayMode === "staff") {
      printGroupByStaffFn();
    } else {
      printGroupByBuildingFn();
    }
  };

  if (getWorkShiftGroup.isPending) return <LoadingData />;
  if (!getWorkShiftGroup.data) return <ElementNotFound />;

  const workShiftGroup = getWorkShiftGroup.data;

  if (["created", "matching"].includes(workShiftGroup.status))
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="flex flex-col items-center bg-white p-8 rounded-md">
          <LoadingSpinner />
          <p className="text-xl font-bold mt-4">現在シフトの作成中です</p>
        </div>
      </div>
    );

  if (workShiftGroup.status === "cancelled")
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="flex flex-col items-center bg-white p-8 rounded-md">
          <p className="text-xl font-bold mt-4">シフトの作成に失敗しました</p>
        </div>
      </div>
    );

  return (
    <div className="flex flex-col h-full">
      <h2 className="text-2xl font-bold py-10 flex-shrink-0">{workShiftGroup.name}のシフト一覧</h2>
      <div className="flex-grow overflow-hidden border bg-white border-base-100 flex flex-col">
        <Header
          displayMode={displayMode}
          setDisplayMode={setDisplayMode}
          workShiftGroup={workShiftGroup}
          onPrint={onPrint}
        />
        {displayMode === "staff" ? (
          <GroupByStaff ref={groupByStaffRef} workShiftGroup={workShiftGroup} />
        ) : (
          <GroupByBuilding ref={groupByBuildingRef} workShiftGroup={workShiftGroup} />
        )}
      </div>
    </div>
  );
};
